export const de = {
  translation: {
    "Belimo Energy Valve": "Belimo Energy Valve",
    Yes: "Ja",
    No: "Nein",
    "You cannot go back from this position":
      "Von dieser Position aus können Sie nicht zurückgehen",
    Chapters: "Kapitel",
    Start: "Start",
    "Connecting to the Energy Valve":
      "Verbindung mit Energy Valve",
    "Control Source": "Steuerungsquelle",
    "Do you know the design flow rate?":
      "Kennen Sie die vorgesehene Durchflussmenge?",
    "Flow Control": "Durchflussregelung",

    "Is the building running off fixed or varying flow temperatures?":
      "Wird das Gebäude mit festen oder wechselnden Vorlauftemperaturen betrieben?",

    "Varying flow temperatures (Delta T Manager Scaling)":
      "Wechselnde Vorlauftemperaturen (Delta-T-Manager-Skalierung)",

    "Fixed flow temperatures (Delta T Manager)":
      "Feste Vorlauftemperaturen (Delta-T-Manager)",

    "I am not sure": "Ich bin nicht sicher",
    "Delta T Manager": "Delta T Manager",
    Scaling: "Skalierung",
    "Do you know the power output?":
      "Kennen Sie die Leistungsabgabe?",
    "Yes (Power Control)": "Ja (Leistungsregelung)",
    "No (Position Control)": "Nein (Positionsregelung)",
    "Power Control": "Leistungsregelung",
    "Position Control": "Positionsregelung",
    "Onboard Data Analysis": "Onboard-Datenanalyse",

    "Did you get a clear result from the Energy Valve?":
      "Haben Sie ein eindeutiges Ergebnis vom Energy Valve erhalten?",

    "How do you want to setup your Energy Valve?":
      "Wie möchten Sie Ihr Energy Valve einstellen?",

    "Would you like to connect to the cloud?":
      "Möchten Sie sich mit der Cloud verbinden?",

    "Cloud Connectivity": "Cloudkonnektivität",

    "Onboard Diagnostics / Download Data":
      "Onboard-Diagnose / Daten herunterladen",

    "Download Data": "Daten herunterladen",
    "Send optimization request":
      "Optimierungsanfrage senden",
    End: "Ende",

    Subtitles: "Untertitel",
    Repeat: "Wiederholen",
    Continue: "Fortsetzen",
  },
};
